import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4245a701&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4245a701')) {
      api.createRecord('4245a701', component.options)
    } else {
      api.reload('4245a701', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4245a701&", function () {
      api.rerender('4245a701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/log/index.vue"
export default component.exports